import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Constant, BaseComponent } from 'app/infrastructure/common/index';
import { OnlineOrderService } from 'app/infrastructure/services/transaction/op/outbound/order/index';
import {SelectItem} from 'primeng/primeng';

import * as _ from 'lodash';

@Component({
    selector: 'app-choose-account',
    templateUrl: './choose-account.html',
    styleUrls: ['./choose-account.css']
})
export class ASNChooseAccountComponent extends BaseComponent implements OnInit {
    @Output() fillInfoEvent = new EventEmitter<any>();

    isLoading = false;
    accounts: SelectItem[] = [];
    selectedAccount: any;

    constructor(private onlineOrderService: OnlineOrderService) {
        super();
    }

    ngOnInit(): void {
        this.loadAccounts();        
    }

    loadAccounts(): void {
        let self = this;
        this.isLoading = true;

        var groupId = this.token.GroupId;
        this.onlineOrderService.getAuthOwnerCustomerReprecentatives(groupId)
            .subscribe(
            data => {
                let message = data;
                if (message && message.MessageType && message.MessageType.Value) {
                    if (message.MessageType.Value == Constant.MessageType.success) {
                        message.Result.forEach(obj => {
                            self.accounts.push({label:obj.OwnerName, value:obj});                            
                        });
                    }
                    else {
                        alert("Error: (" + message.MessageNumber + ") " + message.Message + "--" + message.AdditionalInformation);
                    }
                }
                else {
                    alert("Unknown error occured.");
                }
                this.isLoading = false;
            },
            error => {
                alert(error);
                this.isLoading = false;
            },
            () => {                                
                let founded = _.find(self.accounts, function (obj) {
                    return obj.value.OwnerCode === self.token.DefaultOwnerCode;
                });

                if (founded)
                {
                    self.selectedAccount = founded.value;
                }
            });
    }

    fillAsn() {
        this.fillInfoEvent.emit(this.selectedAccount.OwnerCode);
    }
}


// WEBPACK FOOTER //
// ./src/app/views/pages/transaction/op/inbound/asn/submit-asn/choose-account/choose-account.component.ts